/*
 * Correlation id for a write. crypto.randomUUID exists only in secure
 * contexts (HTTPS, localhost); the HMI on a gateway is opened over plain
 * http in the LAN (http://10.10.50.52:8480/hmi/), where it is missing and
 * every write failed with "crypto.randomUUID is not a function". The id
 * only has to be unique enough to match an acknowledgement to its write.
 */
export function correlationId(): string {
  const c = (globalThis as { crypto?: Crypto }).crypto;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  const b = new Uint8Array(16);
  if (c && typeof c.getRandomValues === 'function') c.getRandomValues(b);
  else for (let i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256);
  b[6] = (b[6]! & 0x0f) | 0x40;
  b[8] = (b[8]! & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
